import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';

export default function ConsentRoute() {
  const consentStatus = useAuthStore((s) => s.consentStatus);

  // Minor students (guardian consent outstanding) get a dedicated waiting
  // screen instead of the general DPDP consent form (Story 3.10, AC6).
  if (consentStatus === 'MINOR_PENDING') {
    return <Navigate to="/pending-guardian-consent" replace />;
  }

  if (consentStatus !== 'GRANTED') {
    return <Navigate to="/consent" replace />;
  }

  return <Outlet />;
}
